import customer from "../../Customers/Commons/Services/index";
import vehicle from "../../Vehicles/Commons/Services/index";
import branch from "../../Destinations/Commons/Services/index";
import area from "../../CoverageArea/Commons/Services/index";
import rate from "../../rates/commons/Services/index";
import reservation from "../../Reservations/Commons/Services/index";
import dashboard from "../../Dashboard/Commons/Services/index";
import upload from "../GeneralServices/Upload/index";
import profile from "../GeneralServices/Profile/index";
import auth from "../GeneralServices/Auth/index";
import country from "../GeneralServices/Country/index";
import surcharge from "../GeneralServices/Surcharge/index";
import flights from "../GeneralServices/Flights/index";
import exportFile from "../GeneralServices/Export/index";
import driver from "../../Drivers/Commons/Services/index";
import user from "../../Users/Commons/Services/index";
import settings from "../GeneralServices/Settings/index";
import operators from "../GeneralServices/Operators/index";
import destinations from "../GeneralServices/Destinations/index";
import documents from "../GeneralServices/Documents/index";
import quotes from "../GeneralServices/Quotes/index";
import tags from "../GeneralServices/Tags/index";
export default {
  dashboard: dashboard,
  reservations: reservation,
  customers: customer,
  vehicles: vehicle,
  branches: branch,
  areas: area,
  rates: rate,
  upload: upload,
  profile: profile,
  auth: auth,
  countries: country,
  surcharges: surcharge,
  flights: flights,
  exports: exportFile,
  users: user,
  drivers: driver,
  settings: settings,
  operators: operators,
  destinations: destinations,
  documents: documents,
  quotes: quotes,
  tags: tags
};
